// features/hive/ui/HiveChartSection/HiveMarkEdit.tsx
import {
    HiveMarkEditBG,
    HiveMarkEditWindow,
    HiveMarkEditWindowFooter,
    HiveMarkEditWindowHeader,
    HiveMarkEditWindowInfoCol,
    HiveMarkEditWindowInfoRow,
    HiveMarkEditWindowTitleRow,
} from "features/hive/ui/HiveChartSection/styles.ts";
import { CloseIcon } from "shared/ui/icons";
import ColorPicker from "features/hives/ui/hivesNew/ColorPicker.tsx";
import { marksColors } from "features/hive/ui/HiveChartSection/consts.ts";
import { Button, Input } from "@atomaro/ui-kit";
import { useEffect, useMemo, useState } from "react";

export type HiveMarkEditPayload = {
    markName: string;
    color: string;
};

type Props = {
    isOpen: boolean;
    mode: "create" | "edit";
    initial?: Partial<HiveMarkEditPayload>;
    onClose: () => void;
    onSave: (payload: HiveMarkEditPayload) => void;
};

const HiveMarkEdit = ({ isOpen, mode, initial, onClose, onSave }: Props) => {
    const defaultColorBg = marksColors[0]?.colorBg ?? "var(--status-01-muted, rgba(187, 128, 255, 1))";

    const [markName, setMarkName] = useState("");
    const [colorBg, setColorBg] = useState(defaultColorBg);

    useEffect(() => {
        if (!isOpen) return;
        setMarkName(initial?.markName ?? "");
        setColorBg(initial?.color ?? defaultColorBg);
    }, [isOpen]); // важно: не отслеживаем markName / color, чтобы не сбрасывалось при вводе

    const title = useMemo(
        () => (mode === "edit" ? "Редактирование метки" : "Создание метки"),
        [mode]
    );

    if (!isOpen) return null;

    return (
        <HiveMarkEditBG>
            <HiveMarkEditWindow>
                <HiveMarkEditWindowHeader>
                    <HiveMarkEditWindowTitleRow>
                        <h3>{title}</h3>
                        <div onClick={onClose}>
                            <CloseIcon />
                        </div>
                    </HiveMarkEditWindowTitleRow>
                    <HiveMarkEditWindowInfoRow>
                        <HiveMarkEditWindowInfoCol>
                            <p>Название метки</p>
                            <Input
                                size="s"
                                value={markName}
                                onChange={(e) => setMarkName(e.target.value)}
                            />
                        </HiveMarkEditWindowInfoCol>
                        <HiveMarkEditWindowInfoCol>
                            <p>Цвет метки</p>
                            <ColorPicker
                                items={marksColors.map((el) => el.colorBg)}
                                initial={colorBg}
                                onChange={(val) => setColorBg(val)}
                            />
                        </HiveMarkEditWindowInfoCol>
                    </HiveMarkEditWindowInfoRow>
                </HiveMarkEditWindowHeader>
                <HiveMarkEditWindowFooter>
                    <Button
                        label="Отменить"
                        variant="ghost"
                        size="l"
                        onClick={onClose}
                    />
                    <Button
                        label="Сохранить"
                        variant="primary"
                        size="l"
                        onClick={() =>
                            onSave({
                                markName: markName.trim(),
                                color: colorBg,
                            })
                        }
                    />
                </HiveMarkEditWindowFooter>
            </HiveMarkEditWindow>
        </HiveMarkEditBG>
    );
};

export default HiveMarkEdit;
